// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { Query } from 'urql';
import {
  GlobalNavLinksV2Query,
  NavLinks,
  SideBarNavLinks,
  convertArray,
} from '@ta/brand.global-nav';
import type { NavLinkType } from '@ta/brand.global-nav';

type Props = {|
  /** Current POS */
  pos: string,
  /** Name of the servlet for current page */
  page: string,
  /** Geo id of current page */
  geoId: string,
  /** Detail id of the current page */
  detailId: ?string,
  /** Longitude of current geo */
  longitude: string,
  /** Latitude of current geo */
  latitude: string,
  /** Whether the link is for side bar or not */
  isSidebar?: boolean,
  /** Callback for expanding sidebar item */
  sidebarItemExpandHandler?: (subLinks: NavLinkType[], e: SyntheticEvent<*>) => void,
|};

const SERVLET_TO_ACTIVE_LINK_ID: Map<string, string> = new Map();
SERVLET_TO_ACTIVE_LINK_ID.set('AttractionProductReview', 'attractions');

class GlobalNavLinksV2 extends React.Component<Props> {
  mapServletToActiveLinkId = (): string => {
    // Emulates the mapping found in SERVLET_TO_ACTIVE_LINK in NavLinksProvider
    const activePageId = SERVLET_TO_ACTIVE_LINK_ID.get(this.props.page);
    if (typeof activePageId === 'string') {
      return activePageId;
    }
    return this.props.geoId ? 'scoped-home' : 'unscoped-home';
  };

  buildNavLinks = (linksData: ?(any[])) => {
    const links: NavLinkType[] = convertArray(linksData);
    const activeLinkId = this.mapServletToActiveLinkId();
    return this.props.isSidebar ? (
      <SideBarNavLinks
        links={links}
        sidebarItemExpandHandler={this.props.sidebarItemExpandHandler}
      />
    ) : (
      <NavLinks links={links} activeLinkId={activeLinkId} sourceOnly={false} />
    );
  };

  render() {
    return (
      <Query
        query={GlobalNavLinksV2Query}
        variables={{
          pos: this.props.pos,
          servlet: this.props.page,
          urlParameters: {
            geo: this.props.geoId,
            detail: this.props.detailId,
            longitude: this.props.longitude,
            latitude: this.props.latitude,
          },
        }}
      >
        {({ fetching, data }) => {
          if (fetching || !data || !data.globalNavLinks || !data.globalNavLinks.sublinks) {
            return null;
          }
          return this.buildNavLinks(data?.globalNavLinks?.sublinks);
        }}
      </Query>
    );
  }
}

export default connect<Props, Object, _, _, _, _>(state => ({
  geoId: state.route.isNearby ? state.page.geoId : state.route.geo,
  detailId: state.route.detail,
  longitude: state.route.longitude,
  latitude: state.route.latitude,
  page: state.route.page === 'Home' && state.route.geo ? 'Tourism' : state.route.page,
  pos: state.i18n.locale,
}))(GlobalNavLinksV2);
